'use client'

import { usePathname } from 'next/navigation'
import { useEffect } from 'react'
import { useAuthStore } from '@/stores/useAuthStore'
import {
    expireSessionService,
    getSessionToken,
    isSupportSession,
    reconcileSession,
} from '~/services/domain/auth/SessionService'
import { useSessionRefresh } from './useSessionRefresh'

/**
 * Confere a sessão a cada navegação (o cookie do token decide; a useAuthStore é cache): token sem cliente no cache
 * recompõe pelo update-token (no suporte, encerra); cliente no cache sem token é sessão expirada. O aviso e a ida para
 * o login ficam com quem ouve o evento `sessionExpired` (o SessionWatcher da casca).
 */
export function useSessionSync() {
    const pathname = usePathname()
    const { refreshSession } = useSessionRefresh()

    // biome-ignore lint/correctness/useExhaustiveDependencies: a conferência roda a cada navegação (pathname).
    useEffect(() => {
        const action = reconcileSession({
            hasToken: Boolean(getSessionToken()),
            hasCache: Boolean(useAuthStore.getState().data?.customer),
            isSupport: isSupportSession(),
        })

        if (action === 'rehydrate') refreshSession().catch(() => {})
        else if (action === 'expire' || action === 'signOut') expireSessionService()
    }, [pathname, refreshSession])
}
